import { JSX } from 'solid-js';

/* Dashed placeholder surface for an empty column. The pre-rebrand version was a white
   card on a white page, so it read as loose text; the dashed border and neutral wash
   make the slot visible without competing with real cards. */
export const EmptyState = (props: { children: JSX.Element }) => (
    <div class="rounded-cvi-md border border-dashed border-cvi-border-default bg-cvi-bg-block-neutral p-cvi-8 text-center body-sm font-cvi-regular text-cvi-fg-muted">
        {props.children}
    </div>
);
